import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Table,
  Modal,
  message,
  Button,
  Form,
  DatePicker,
  Drawer,
  Select,
} from "antd";
import "./index.scss";
import NProgress from "nprogress";
import { fetchAddActivity, fetchEvaluationList } from "../../../api/evaluation";
import { fetchGoodsList } from "../../../api/recommendGoods";
import moment from "moment";
const { Column } = Table;
const { Option } = Select;
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/activityCenter", name: "测评活动中心" },
];

const formItemLayout = {
  labelCol: {
    xs: { span: 10 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 38 },
    sm: { span: 20 },
  },
};
class ActivityCenter extends React.Component {
  state = {
    active: sessionStorage.getItem("activityTabs")
      ? Number(sessionStorage.getItem("activityTabs"))
      : 1,
    now_listQuery: {
      goodsName: "",
      pageNum: 1,
      pageSize: 10,
      state: 0,
    },
    now_list: [],
    now_total: 0,
    history_listQuery: {
      goodsName: "",
      bonusTimeState: 0,
      pageNum: 1,
      pageSize: 10,
      state: 1,
    },
    history_list: [{ id: 1 }],
    history_total: 0,
    bigImgUrl: "",
    bigImgVisible: false,
    activityVisible: false,
    goodsMallVisible: false,
    goods_listQuery: {
      goodsName: "",
      brandName: "",
      pageNum: 1,
      pageSize: 20,
      evaluation: true,
    },
    goods_list: [],
    goods_total: 0,
    selectedRowKeys: [],
    currentGoods: {},
    btnLoading: false,
  };
  componentDidMount() {
    NProgress.start();
    this.getList();
    NProgress.done();
  }
  getGoodsList = () => {
    return new Promise((resolve) => {
      fetchGoodsList(this.state.goods_listQuery).then((res) => {
        if (res.success) {
          this.setState({
            goods_list: res.data.list,
            goods_total: res.data.total,
          });
        }
        resolve();
      });
    });
  };
  getList = () => {
    switch (this.state.active) {
      case 1:
        fetchEvaluationList(this.state.now_listQuery).then((res) => {
          if (res.success) {
            this.setState({
              now_list: res.data.list,
              now_total: res.data.total,
            });
          }
        });
        break;
      case 2:
        fetchEvaluationList(this.state.history_listQuery).then((res) => {
          if (res.success) {
            this.setState({
              history_list: res.data.list,
              history_total: res.data.total,
            });
          }
        });
        break;
      default:
        break;
    }
  };
  changeTabs = (e) => {
    this.setState(
      {
        active: e,
      },
      () => {
        this.getList();
      }
    );
  };
  selectChange = (e, state) => {
    this.setState({
      history_listQuery: {
        ...this.state.history_listQuery,
        [state]: e,
      },
    });
  };
  goods_inputChange = (e) => {
    this.setState({
      goods_listQuery: {
        ...this.state.goods_listQuery,
        [e.target.name]: e.target.value,
      },
    });
  };
  goods_handleSearch = () => {
    this.setState(
      {
        goods_listQuery: { ...this.state.goods_listQuery, pageNum: 1 },
      },
      () => this.getGoodsList()
    );
  };
  inputChange = (e) => {
    switch (this.state.active) {
      case 1:
        this.setState({
          now_listQuery: {
            ...this.state.now_listQuery,
            [e.target.name]: e.target.value,
          },
        });
        break;
      case 2:
        this.setState({
          history_listQuery: {
            ...this.state.history_listQuery,
            [e.target.name]: e.target.value,
          },
        });
        break;
    }
  };
  handleSearch = () => {
    switch (this.state.active) {
      case 1:
        this.setState(
          {
            now_listQuery: { ...this.state.now_listQuery, pageNum: 1 },
          },
          () => this.getList()
        );
        break;
      case 2:
        this.setState(
          {
            history_listQuery: { ...this.state.history_listQuery, pageNum: 1 },
          },
          () => this.getList()
        );
        break;
      default:
        break;
    }
  };
  showBigImg = (url) => {
    this.setState({
      bigImgVisible: true,
      bigImgUrl: url,
    });
  };
  viewDetails = (value, tabs) => {
    sessionStorage.setItem("activityTabs", tabs);
    if (tabs == 1) {
      this.props.history.push(
        "/page/ssry/activityDetails/" + value.tryEvaluationGoodsId
      );
    } else if (tabs == 2) {
      this.props.history.push(
        "/page/ssry/historyActivityDetails/" + value.tryEvaluationGoodsId
      );
    }
  };
  activityCancel = () => {
    this.props.form.resetFields();
    this.setState({
      activityVisible: false,
    });
  };
  activityOk = (e, close) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          btnLoading: true,
        });
        values.endTime = moment(values.endTime).format("YYYY-MM-DD");
        fetchAddActivity({
          materialsId: this.state.currentGoods.materialsId,
          endTime: values.endTime,
        }).then((res) => {
          this.setState({
            btnLoading: false,
          });
          if (res.success) {
            message.success("操作成功");
            this.getList();
            if (close) {
              this.activityCancel();
            } else {
              this.props.form.resetFields();
            }
          }
        });
      }
    });
  };
  chooseGoods = async () => {
    await this.getGoodsList();
    this.setState({
      goodsMallVisible: true,
    });
  };
  goodsMallClose = () => {
    this.setState({
      goodsMallVisible: false,
      selectedRowKeys: [],
    });
  };
  selectGoods = (value) => {
    this.props.form.setFieldsValue({ goodsName: value.name });
    this.setState(
      {
        selectedRowKeys: [value.materialsId],
        currentGoods: value,
      },
      () => {
        this.goodsMallClose();
      }
    );
  };
  render() {
    const { getFieldDecorator } = this.props.form;

    const {
      active,
      now_listQuery,
      now_list,
      now_total,
      history_listQuery,
      history_list,
      history_total,
      goods_listQuery,
      goods_list,
      goods_total,
      bigImgUrl,
      bigImgVisible,
      activityVisible,
      goodsMallVisible,
      selectedRowKeys,
      currentGoods,
      btnLoading,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="activityCenter_container">
          <div className="tabs">
            <div
              onClick={() => this.changeTabs(1)}
              className={active == 1 ? "item active" : "item"}
            >
              进行中活动
            </div>
            <div
              onClick={() => this.changeTabs(2)}
              className={active == 2 ? "item active" : "item"}
            >
              往期活动
            </div>
            <div
              style={{ left: (active - 1) * 104 }}
              className="bottomLine"
            ></div>
            <Button
              onClick={() => {
                this.setState({
                  activityVisible: true,
                });
              }}
              className="fr"
              type="primary"
            >
              添加活动
            </Button>
          </div>
          <div className={active == 1 ? "content" : "none"}>
            <div style={{ marginBottom: 16 }}>
              <Input
                style={{ width: 150 }}
                className="marginR"
                onChange={this.inputChange}
                name="goodsName"
                placeholder="商品名称"
                allowClear
              ></Input>
              <Button type="primary" onClick={this.handleSearch}>
                搜索
              </Button>
            </div>
            <Table
              rowKey="tryEvaluationGoodsId"
              dataSource={now_list}
              // locale={{ emptyText: "暂无商户" }}
              pagination={{
                showTotal: () => `共${now_total}条`,
                total: now_total,
                current: now_listQuery.pageNum,
                pageSize: now_listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      now_listQuery: { ...now_listQuery, pageNum: page },
                    },
                    () => this.getList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      now_listQuery: { ...now_listQuery, pageSize, pageNum: 1 },
                    },
                    () => this.getList()
                  );
                },
              }}
            >
              <Column
                title="活动序号"
                dataIndex="tryEvaluationGoodsId"
                key="tryEvaluationGoodsId"
                render={(a, b, index) =>
                  index +
                  1 +
                  (now_listQuery.pageNum - 1) * now_listQuery.pageSize
                }
              />
              <Column title="商品名称" dataIndex="goodsName" key="goodsName" />
              <Column
                title="商品图片"
                dataIndex="pic"
                key="pic"
                render={(text) => (
                  <img
                    onClick={() => this.showBigImg(text)}
                    style={{ width: 40, height: 40, cursor: "pointer" }}
                    src={text}
                  ></img>
                )}
              />
              <Column
                title="活动截止日期"
                dataIndex="endTime"
                key="endTime"
                render={(value) => (value ? value.split(" ")[0] : "")}
              />
              <Column
                title="参与人数"
                dataIndex="participateNum"
                key="participateNum"
              />

              <Column
                title="操作"
                render={(value, record) => (
                  <a onClick={() => this.viewDetails(record, 1)}>查看详情</a>
                )}
              />
            </Table>
          </div>
          <div className={active == 2 ? "content" : "none"}>
            <div style={{ marginBottom: 16 }}>
              <Input
                style={{ width: 150 }}
                className="marginR"
                onChange={this.inputChange}
                name="goodsName"
                placeholder="商品名称"
                allowClear
              ></Input>
              <Select
                value={history_listQuery.bonusTimeState}
                className="marginR"
                style={{ width: 150 }}
                onChange={(e) => this.selectChange(e, "bonusTimeState")}
              >
                <Option value={1}>已到奖金发放日</Option>
                <Option value={2}>未到奖金发放日</Option>
                <Option value={0}>全部活动</Option>
              </Select>
              <Button type="primary" onClick={this.handleSearch}>
                搜索
              </Button>
            </div>
            <Table
              rowKey={() => Math.random()}
              dataSource={history_list}
              // locale={{ emptyText: "暂无商户" }}
              pagination={{
                showTotal: () => `共${history_total}条`,
                total: history_total,
                current: history_listQuery.pageNum,
                pageSize: history_listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      history_listQuery: {
                        ...history_listQuery,
                        pageNum: page,
                      },
                    },
                    () => this.getList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      history_listQuery: {
                        ...history_listQuery,
                        pageSize,
                        pageNum: 1,
                      },
                    },
                    () => this.getList()
                  );
                },
              }}
            >
              <Column
                title="活动序号"
                dataIndex="tryEvaluationGoodsId"
                key="tryEvaluationGoodsId"
                render={(a, b, index) =>
                  index +
                  1 +
                  (now_listQuery.pageNum - 1) * now_listQuery.pageSize
                }
              />
              <Column title="商品名称" dataIndex="goodsName" key="goodsName" />
              <Column
                title="商品图片"
                dataIndex="pic"
                key="pic"
                render={(text) => (
                  <img
                    onClick={() => this.showBigImg(text)}
                    style={{ width: 40, height: 40, cursor: "pointer" }}
                    src={text}
                  ></img>
                )}
              />
              <Column
                title="活动截止日期"
                dataIndex="endTime"
                key="endTime"
                render={(value) => (value ? value.split(" ")[0] : "")}
              />{" "}
              <Column
                title="奖金发放日期"
                dataIndex="bonusTime"
                key="bonusTime"
                render={(value) => (value ? value.split(" ")[0] : "")}
              />
              <Column
                title="参与人数"
                dataIndex="participateNum"
                key="participateNum"
              />
              <Column
                title="奖金状态"
                dataIndex="bonusState"
                key="bonusState"
                render={(value) => {
                  switch (value) {
                    case 0:
                      return "未发放";
                      break;
                    case 1:
                      return <span style={{ color: "#66B60E" }}>已发放</span>;
                      break;
                    default:
                      break;
                  }
                }}
              />
              <Column
                title="操作"
                render={(value, record) => (
                  <a onClick={() => this.viewDetails(record, 2)}>查看详情</a>
                )}
              />
            </Table>
          </div>
        </div>

        <Drawer
          className="goodsDrawer"
          title="添加商品"
          placement="right"
          onClose={this.goodsMallClose}
          visible={goodsMallVisible}
        >
          <div>
            <span style={{ color: "#D0021B" }}>*</span>
            一个商品只能建立一个活动，故活动中商品不显示在列表中
          </div>
          <div className="searchWrap">
            <Input
              style={{ width: 150 }}
              className="marginR"
              onChange={this.goods_inputChange}
              name="goodsName"
              placeholder="商品名称"
              allowClear
            ></Input>
            <Input
              style={{ width: 150 }}
              className="marginR"
              onChange={this.goods_inputChange}
              name="brandName"
              placeholder="品牌"
              allowClear
            ></Input>
            <Button type="primary" onClick={this.goods_handleSearch}>
              搜索
            </Button>
          </div>
          <Table
            rowSelection={{
              type: "radio",
              onSelect: this.selectGoods,
              selectedRowKeys,
            }}
            rowKey="materialsId"
            dataSource={goods_list}
            // locale={{ emptyText: "暂无商户" }}
            pagination={{
              showTotal: () => `共${goods_total}条`,
              total: goods_total,
              current: goods_listQuery.pageNum,
              pageSize: goods_listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    goods_listQuery: { ...goods_listQuery, pageNum: page },
                  },
                  () => this.getGoodsList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    goods_listQuery: {
                      ...goods_listQuery,
                      pageSize,
                      pageNum: 1,
                    },
                  },
                  () => this.getGoodsList()
                );
              },
            }}
          >
            <Column title="商品名称" dataIndex="name" key="name" />
            <Column title="品牌" dataIndex="brandName" key="brandName" />
            <Column title="售价" dataIndex="price" key="price" />

            <Column
              title="商品图片"
              dataIndex="pic"
              key="pic"
              render={(text) => (
                <img
                  onClick={() => this.showBigImg(text)}
                  style={{ width: 40, height: 40, cursor: "pointer" }}
                  src={text}
                ></img>
              )}
            />
          </Table>
        </Drawer>
        <Modal
          title="添加活动"
          width="700px"
          visible={activityVisible}
          onOk={this.activityOk}
          onCancel={this.activityCancel}
          footer={[
            <Button
              loading={btnLoading}
              style={{ color: "#1890FF", borderColor: "#1890FF" }}
              onClick={(e) => this.activityOk(e, false)}
            >
              确定并添加下一个
            </Button>,
            <Button
              loading={btnLoading}
              key="submit"
              type="primary"
              onClick={(e) => this.activityOk(e, true)}
            >
              确定
            </Button>,
          ]}
        >
          <Form onSubmit={this.activityOk} {...formItemLayout}>
            <Form.Item label="活动商品">
              {getFieldDecorator("goodsName", {
                rules: [{ required: true, message: "请选择参加活动的商品" }],
              })(
                <Input
                  disabled
                  className="marginR"
                  style={{ width: 200 }}
                  placeholder="请选择参加活动的商品"
                />
              )}
              <Button onClick={this.chooseGoods} type="primary">
                选择商品
              </Button>
            </Form.Item>

            <Form.Item label="活动截止时间">
              {getFieldDecorator("endTime", {
                rules: [{ required: true, message: "请选择活动截止时间" }],
              })(
                <DatePicker
                  style={{ width: 200 }}
                  placeholder="请选择活动截止时间"
                />
              )}
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title="图片预览"
          onCancel={() => this.setState({ bigImgVisible: false })}
          visible={this.state.bigImgVisible}
          footer={null}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src={this.state.bigImgUrl}
          ></img>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(ActivityCenter);
